"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenuItemText = exports.StyledFilterDropdownGlobal = exports.StyledFilterDropdownButtons = exports.StyledFilterDropdown = exports.StyledFilterContentContainer = exports.MenuItemRadioCheckboxWrapper = exports.MenuItemContentWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = require("../../ykb-styled-components");
var _StyledButton = require("../../Button/StyledButton");
var _StyledCheckbox = require("../../Checkbox/StyledCheckbox");
var StyledFilterDropdownButtons = exports.StyledFilterDropdownButtons = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-1sduyq4-0"
})([""]);
var StyledFilterContentContainer = exports.StyledFilterContentContainer = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-1sduyq4-1"
})([""]);
var MenuItemContentWrapper = exports.MenuItemContentWrapper = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-1sduyq4-2"
})(["height:37px;position:relative;padding:", ";"], function (props) {
  return props.theme.dropdown.listItem.padding;
});
var MenuItemRadioCheckboxWrapper = exports.MenuItemRadioCheckboxWrapper = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-1sduyq4-3"
})(["position:absolute;z-index:1;"]);
var StyledMenuItemText = exports.StyledMenuItemText = _ykbStyledComponents.styled.span.withConfig({
  componentId: "ykb-ui__sc-1sduyq4-4"
})(["position:absolute;z-index:2;left:0;padding-left:35px;width:100%;text-overflow:ellipsis;overflow:hidden;"]);
var StyledFilterDropdownGlobal = exports.StyledFilterDropdownGlobal = (0, _ykbStyledComponents.createGlobalStyle)([".", "-filter-dropdown{position:relative;min-width:96px;margin-left:-8px;background:#fff;border-radius:4px;box-shadow:0 1px 6px rgba(0,0,0,0.2);", "{padding:10px;max-width:300px;p{margin:5px 0;}form{margin-top:0;}.", "-input-affix-wrapper{font-size:12px;min-width:0;.", "-input{min-width:90px;}}.", "-ui-button-link{font-size:12px;}}.", "-dropdown-menu{outline:none;position:relative;background-clip:padding-box;list-style-type:none;padding:", ";margin:", ";text-align:left;background-color:#fff;border:0;border-radius:", " ", " 0 0;box-shadow:none;max-height:250px;overflow:auto;&:before{content:'';position:absolute;top:-4px;left:0;width:100%;height:4px;background:", ";}&-item{position:relative;display:block;clear:both;font-size:", ";font-weight:", ";line-height:", ";color:", ";background-color:", ";white-space:nowrap;color:", ";cursor:pointer;max-width:280px;overflow:hidden;text-overflow:ellipsis;overflow-wrap:break-word;", "{margin-right:5px;}> label{padding-right:5px;margin-right:0px !important;}> label  + span{padding-right:0;}&:hover,&-active{color:", ";background-color:", ";cursor:pointer;}&-selected{color:", ";background-color:", ";cursor:pointer;&:hover{background-color:", " !important;}}&-disabled{color:", ";background:", " !important;cursor:not-allowed;pointer-events:none;}&:last-child{border-bottom-left-radius:", ";border-bottom-right-radius:", ";}&:first-child{border-top-left-radius:", ";border-top-right-radius:", ";}&-sub{border-radius:", ";box-shadow:", ";}&-divider{height:", ";margin:", ";overflow:hidden;background-color:", ";line-height:0;}}}", "{padding:7px 8px;overflow:hidden;border-top:", ";", "{line-height:30px;}button:last-child{margin-right:0;}}&-link{color:", ";&:hover{color:", ";}&:active{color:", ";}&.confirm{float:left;}&.clear{float:right;}}}"], function (props) {
  return props.prefixCls;
}, StyledFilterContentContainer, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.dropdown.box.padding;
}, function (props) {
  return props.theme.dropdown.box.margin;
}, function (props) {
  return props.theme.component.borderRadius;
}, function (props) {
  return props.theme.component.borderRadius;
}, function (props) {
  return props.theme.dropdown.box.borderTopColor;
}, function (props) {
  return props.theme.dropdown.listItem.fontSize;
}, function (props) {
  return props.theme.dropdown.listItem.fontWeight;
}, function (props) {
  return props.theme.dropdown.listItem.lineHeight;
}, function (props) {
  return props.theme.dropdown.listItem.color;
}, function (props) {
  return props.theme.dropdown.listItem.backgroundColor;
}, function (props) {
  return props.theme.color.neutral11;
}, _StyledCheckbox.StyledCheckbox, function (props) {
  return props.theme.color.neutral11;
}, function (props) {
  return props.theme.color.default1;
}, function (props) {
  return props.theme.color.neutral11;
}, function (props) {
  return props.theme.color.primary1;
}, function (props) {
  return props.theme.color.primary2;
}, function (props) {
  return props.theme.dropdown.listItem.disabledColor;
}, function (props) {
  return props.theme.dropdown.listItem.disabledBackgroundColor;
}, function (props) {
  return props.theme.dropdown.border.radius;
}, function (props) {
  return props.theme.dropdown.border.radius;
}, function (props) {
  return props.theme.dropdown.border.radius;
}, function (props) {
  return props.theme.dropdown.border.radius;
}, function (props) {
  return props.theme.component.borderRadius;
}, function (props) {
  return props.theme.component.shadow;
}, function (props) {
  return props.theme.dropdown.divider.height;
}, function (props) {
  return props.theme.dropdown.divider.margin;
}, function (props) {
  return props.theme.dropdown.divider.backgroundColor;
}, StyledFilterDropdownButtons, function (props) {
  return "".concat(props.theme.table.borderWidth, " ").concat(props.theme.table.borderStyle, " ").concat(props.theme.table.borderColor);
}, _StyledButton.Link, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary5;
}, function (props) {
  return props.theme.color.primary5;
});
var StyledFilterDropdown = exports.StyledFilterDropdown = /*#__PURE__*/_react.default.memo(StyledFilterDropdownGlobal);